<section class="container-fluid sts-section sts-form signin-section">

  <app-sts-section-header key="sts-sigin-header" [errors]="errors">
    Sign In
    <app-sts-section-header-side>
        <div class="text-right"><a
          routerLink="/account/help" app-sts-cms-txt key="sts-need-help">Need help?</a>
        </div>
    </app-sts-section-header-side>
  </app-sts-section-header>


  <app-sts-section-body key="signin" Content regPrefix regTitle regSuffix (renderingComplete)="sidebarLoaded($event)"></app-sts-section-body>

  <app-sts-section-footer Prefix needHelpTitle forgotPasswordTitle Suffix (renderingComplete)="sidebarLoaded($event)"></app-sts-section-footer>

  <form #form="ngForm" (ngSubmit)="onSubmit()" class="sts-form" autocomplete="off" method="POST">

        <div class="row sts-label-row">
          <div class="col-12 label-node"
            [ngClass]="{'login-username-fr': tenantInfo.currentLocale == 'fr-CA'}" >
            <label for="userName" app-sts-cms-txt key="sts-user-id">
              User ID:
              <!-- Code d’utilisateur : -->
              </label>
          </div>
          <div class="col-12">
            <div *ngIf="tenantInfo.isUserNameRecoverySupported" class="text-right"><a
              routerLink="/account/forgot-username/" app-sts-cms-txt key="sts-forgot-your-user-id">Forgot your user ID?</a></div>
          </div>
        </div>

        <div class="row sts-input-row">
          <div class="col-24">
            <input type="text" class="sts-textbox "
                   [ngClass]="{'has-errors': !usernameValid}"
                   id="userName" [(ngModel)]="stsUser.userName"
                   #userName="ngModel" name="userName"
                   aria-required="true"/>
            <app-sts-show-error key="sts-field-error-userid-required" description="User ID is a required field" [show]="!usernameValid"></app-sts-show-error>
          </div>
        </div>

        <div class="row sts-label-row">
          <div class="col-12 label-node"
            [ngClass]="{'login-password-fr': tenantInfo.currentLocale == 'fr-CA'}" >
            <label for="password"
                   app-sts-cms-txt
                   key="sts-password">
                   Password:
                   <!-- Mot de Passe : -->
                   </label>
          </div>
          <div class="col-12">
            <div class="text-right"><a
              routerLink="/account/forgot-password" app-sts-cms-txt key="sts-need-forgot-password">Forgot your password?</a></div>
          </div>
        </div>

        <div class="row sts-input-row">
          <div class="col-24">
            <input type="password" class="sts-textbox "
                   [ngClass]="{'has-errors': !passwordValid}"
                   id="password" [(ngModel)]="stsUser.password"
                   #password="ngModel" name="password"
                   aria-required="true"/>
            <app-sts-show-error key="sts-field-error-Password-required" description="Password is a required field" [show]="!passwordValid"></app-sts-show-error>
          </div>
        </div>


        <div class="row ">
          <div class="col-12">
            <app-sts-button
              class="sts-sign-in-button"
              [disabled]="disableSubmit"
              key="sts-sign-in-button-label">
                Sign in
            </app-sts-button>
          </div>

          <div class="col-12 text-right">
            <div class="self-reg-link" *ngIf="tenantInfo.isSelfRegSupported">
              <a routerLink="/account/reg-step-1" app-sts-cms-txt key="sts-self-registeration">
                Self-registration
              </a>
            </div>
          </div>

        </div>
      </form>

</section>
